export const getTheme = className => {
  const theme = localStorage.getItem('theme')
    ? localStorage.getItem('theme')
    : 'default';

  if (theme === 'wcag') {
    return `nd-${className}`;
  } else {
    return className;
  }
};

export const getFont = className => {
  const font = localStorage.getItem('font')
    ? localStorage.getItem('font')
    : 'default';

  if (font === 'bigger') {
    return `fn-${className}`;
  } else {
    return className;
  }
};
